import React from "react";
import MatchListItem from "./MatchListItem";
import "../styles/matchDaysStyles.css";
import { useTranslation } from "react-i18next";

/**
 * @property {array} matches
 * @property {boolean} withForm
 * @returns {React.ReactElement} List of matches styled according to matchDay page design.
 */
export default function MatchList({
    matches = [],
    withForm = true,
    matchDayId = null,
    disabled = false,
    matchDay,
}) {
    const { t } = useTranslation();

    const validMatches = Array.isArray(matches)
        ? matches.filter((match) => match)
        : [];

    return (
        <div
            className={`match-list-wrap ${disabled && "disabled"} ${
                !validMatches?.length && "no-matches"
            }`}
        >
            {validMatches?.length ? (
                validMatches.map((match) => (
                    <MatchListItem
                        match={match}
                        withForm={withForm}
                        matchDayId={matchDayId}
                        key={match?.id}
                        matchDay={matchDay}
                    />
                ))
            ) : (
                <span className="no-matches-msg">
                    {t("gamedays.matches_list.no_matches_msg")}
                </span>
            )}
        </div>
    );
}
